export class OutboundResponseError {
    // these are success
    public static HandsetReceivedContent =
        new OutboundResponseError("HandsetReceivedContent", "Handset recieved content.");
    public static NoWaitRequested =
        new OutboundResponseError("NoWaitRequested", "Unknown, no wait requested.");
    public static MaxWaitDurationExceeded =
        new OutboundResponseError("MaxWaitDurationExceeded", "The device did not respond. Please check to make sure the device is on and has an internet connection.");
    public static BNumberNotActive =
        new OutboundResponseError("BNumberNotActive", "The device did not respond. Please confirm the device is Engage enabled.");

    // these are errors
    public static GenericBadRequest =
        new OutboundResponseError("GenericBadRequest", "Bad request.");
    public static ProgramVersionNotFound =
        new OutboundResponseError("ProgramVersionNotFound", "Program version was not found.");
    public static AssetNotAssigned =
        new OutboundResponseError("AssetNotAssigned", "Program version has no asset.");
    public static AssetHasNoContent =
        new OutboundResponseError("AssetHasNoContent", "Asset has no content.");
    public static ContentWouldExpireInThePast =
        new OutboundResponseError("ContentWouldExpireInThePast", "Content would expire in the past.");
    public static NotAllowedToUseANumber =
        new OutboundResponseError("NotAllowedToUseANumber", "You are not allowed to use that ANumber.");
    public static HandsetError =
        new OutboundResponseError("HandsetError", "Handset encountered an error.");

    public static UnknownError =
        new OutboundResponseError("UnknownError", "Encountered an unexpected error.");

    constructor(private innerValue: string, private innerDisplay: string) { }

    public get value(): string {
        return this.innerValue;
    }

    public get display(): string {
        return this.innerDisplay;
    }

    public static convert(purpose: string | null): OutboundResponseError | null {
        const result = OutboundResponseError.all.find((x) => x.value === purpose);
        return result || OutboundResponseError.UnknownError;
    }

    public static all: OutboundResponseError[] = [
        OutboundResponseError.HandsetReceivedContent,
        OutboundResponseError.NoWaitRequested,
        OutboundResponseError.MaxWaitDurationExceeded,
        OutboundResponseError.BNumberNotActive,
        OutboundResponseError.GenericBadRequest,
        OutboundResponseError.ProgramVersionNotFound,
        OutboundResponseError.AssetNotAssigned,
        OutboundResponseError.AssetHasNoContent,
        OutboundResponseError.ContentWouldExpireInThePast,
        OutboundResponseError.NotAllowedToUseANumber,
        OutboundResponseError.HandsetError
    ];
}
